var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button2"},[_c('el-button',{class:{ 'manual' : _vm.type2 == '1' },attrs:{"type":_vm.type,"round":""}},[_vm._v(_vm._s(_vm.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }